class BrowseConstants {
  static A4_RATIO = 1.4142;
  static LETTER_RATIO = 1.2941;
  static THUMBNAIL_WIDTH = 80;
  static THUMBNAIL_HEIGHT = Math.round(
    this.THUMBNAIL_WIDTH * this.LETTER_RATIO
  );
  static DROPZONE_WIDTH = 36;
}

export default BrowseConstants;
